/* index.js */

"use strict";
module.exports = {
    defaultFormatter,
    actionButtonsFormatter,
    labelValuePairFormatter,
    actionButtonsRedactionFormatter,
    actionButtonsAllowedFormatter,
    checkboxFormatter,
    actionButtonsExclusionsFormatter,
    exclusionValueFormatter,
};
function defaultFormatter(row, cell, value) {
    const createdByEl = document.createElement("div");
    createdByEl.classList.add("default-value");
    createdByEl.setAttribute("title", value);
    createdByEl.innerHTML = value;
    return createdByEl.outerHTML;
}
function labelValuePairFormatter(row, cell, value, columnDef) {
    return defaultFormatter(row, cell, columnDef.labelValueMap[value] || value);
}
function actionButtonsFormatter(row, cell, value, columnDef, dataContext) {
    const buttonsContainer = document.createElement("div");
    buttonsContainer.classList.add("buttons-container");
    const editButton = document.createElement("base-icon-gl");
    editButton.dataset.icon = "common.single_edit";
    editButton.setDarkTheme(true);
    editButton.setAttribute("title", "Edit Command Set");
    editButton.setAttribute("role", "button");
    editButton.dataset.uuid = dataContext.id;
    editButton.dataset.action = "edit";
    const cloneButton = document.createElement("base-icon-gl");
    cloneButton.dataset.icon = "common.duplicate";
    cloneButton.setDarkTheme(true);
    cloneButton.setAttribute("title", "Clone Command Set");
    cloneButton.setAttribute("role", "button");
    cloneButton.dataset.uuid = dataContext.id;
    cloneButton.dataset.action = "clone";
    const deleteButton = document.createElement("base-icon-gl");
    deleteButton.dataset.icon = "common.trash_bin";
    deleteButton.setDarkTheme(true);
    deleteButton.setAttribute("title", "Delete Command Set");
    deleteButton.setAttribute("role", "button");
    deleteButton.dataset.uuid = dataContext.id;
    deleteButton.dataset.action = "delete";
    buttonsContainer.appendChild(editButton);
    buttonsContainer.appendChild(cloneButton);
    buttonsContainer.appendChild(deleteButton);
    return buttonsContainer.outerHTML;
}
function actionButtonsRedactionFormatter(row, cell, value, columnDef, dataContext) {
    const buttonsContainer = document.createElement("div");
    buttonsContainer.classList.add("buttons-container");
    const editButton = document.createElement("base-icon-gl");
    editButton.dataset.icon = "common.single_edit";
    editButton.setDarkTheme(true);
    editButton.setAttribute("title", "Edit Redaction");
    editButton.setAttribute("role", "button");
    editButton.dataset.uuid = dataContext.id;
    editButton.dataset.action = "editR";
    const deleteButton = document.createElement("base-icon-gl");
    deleteButton.dataset.icon = "common.trash_bin";
    deleteButton.setDarkTheme(true);
    deleteButton.setAttribute("title", "Delete Redaction");
    deleteButton.setAttribute("role", "button");
    deleteButton.dataset.uuid = dataContext.id;
    deleteButton.dataset.action = "deleteR";
    buttonsContainer.appendChild(editButton);
    buttonsContainer.appendChild(deleteButton);
    return buttonsContainer.outerHTML;
}
function actionButtonsAllowedFormatter(row, cell, value, columnDef, dataContext) {
    const buttonsContainer = document.createElement("div");
    const deleteButton = document.createElement("base-icon-gl");
    deleteButton.dataset.icon = "common.trash_bin";
    deleteButton.setDarkTheme(true);
    deleteButton.setAttribute("title", "Delete Command");
    deleteButton.setAttribute("role", "button");
    deleteButton.dataset.uuid = dataContext.id;
    deleteButton.dataset.action = "deleteA";
    buttonsContainer.appendChild(deleteButton);
    return buttonsContainer.outerHTML;
}

function checkboxFormatter(row, cell, value /*, columnDef, dataContext*/) {
    let checkbox = document.createElement("div");
    if (value) {
        checkbox = document.createElement("base-icon-gl");
        checkbox.dataset.icon = "common.check";
        checkbox.setDarkTheme(true);
    }
    return checkbox.outerHTML;
}

function actionButtonsExclusionsFormatter(row, cell, value, columnDef, dataContext) {
    const buttonsContainer = document.createElement("div");
    buttonsContainer.classList.add("buttons-container");
    const editButton = document.createElement("base-icon-gl");
    editButton.dataset.icon = "common.single_edit";
    editButton.setDarkTheme(true);
    editButton.setAttribute("title", "Edit Exclusion");
    editButton.setAttribute("role", "button");
    editButton.dataset.uuid = dataContext.id;
    editButton.dataset.action = "editEx";
    const deleteButton = document.createElement("base-icon-gl");
    deleteButton.dataset.icon = "common.trash_bin";
    deleteButton.setDarkTheme(true);
    deleteButton.setAttribute("title", "Delete Exclusion");
    deleteButton.setAttribute("role", "button");
    deleteButton.dataset.uuid = dataContext.id;
    deleteButton.dataset.action = "deleteEx";
    buttonsContainer.appendChild(editButton);
    buttonsContainer.appendChild(deleteButton);

    if (!dataContext.hasPerm) {
        editButton.classList.add("disabled");
        deleteButton.classList.add("disabled");
    }

    return buttonsContainer.outerHTML;
}

function exclusionValueFormatter(row, cell, value, columnDef, dataContext) {
    const valContainer = document.createElement("span");
    let val;
    switch (dataContext.exType) {
        case "deviceType":
            val = dataContext.typeBaseMap[value] || value;
            break;
        case "hostName":
            val = value;
            break;
        case "ipAddress":
            val = value;
            break;
        case "ipBlock":
            val = value;
            break;
        case "ipRange":
            val = `${value.start} - ${value.end}`;
            break;
        case "serialNumber":
            val = value;
            break;
        default:
            val = value;
            break;
    }
    valContainer.innerText = val;
    valContainer.setAttribute("title", val);
    return valContainer.outerHTML;
}
